/* eslint react-hooks/exhaustive-deps: "warn" */
import cn from 'classnames';

import styles from './RegistryMarquee.module.scss';

type RegistryItem = { flag: string; name: string };

type Props = {
  items: RegistryItem[];
  theme?: 'light' | 'dark';
  moreLabel?: string;
  className?: string;
};

// A horizontal auto-width pill ticker. Distinct from InfiniteScroller, which
// forces a fixed per-slide width (built for logos) and clips variable-width text pills.
export const RegistryMarquee = ({ items, theme = 'light', moreLabel = '+ 380 more', className }: Props) => {
  const renderSet = (hidden?: boolean) => (
    <div className={styles.set} aria-hidden={hidden || undefined}>
      {items.map((item) => (
        <span key={item.name} className={styles.pill}>
          <span className={styles.flag}>{item.flag}</span>
          {item.name}
        </span>
      ))}
      <span className={cn(styles.pill, styles.more)}>{moreLabel}</span>
    </div>
  );

  return (
    <div className={cn(styles.root, styles[`theme_${theme}`], className)} aria-label="Government registries covered">
      <div className={styles.track}>
        {renderSet()}
        {renderSet(true)}
      </div>
    </div>
  );
};
